import NextLink from "@/components/case-study/common/NextLink";
import Accordion from "@/components/case-study/social-networking-app/Accodian";
import AccordionScroll from "@/components/case-study/social-networking-app/AccordianScroll";
import Card from "@/components/case-study/social-networking-app/Card";
import FeedbackScroll from "@/components/case-study/social-networking-app/FeedbackScroll";
import LinxFeedback from "@/components/case-study/social-networking-app/LinxFeedback";
import LinxVideo from "@/components/case-study/social-networking-app/LinxVideo";
import OurApproach from "@/components/case-study/social-networking-app/OurApproach";
import Requirements from "@/components/case-study/social-networking-app/Requirements";
import Result from "@/components/case-study/social-networking-app/Result";
import ResultScroll from "@/components/case-study/social-networking-app/ResultScroll";
import Scroll from "@/components/case-study/social-networking-app/Scroll";
import TextScroll from "@/components/case-study/social-networking-app/TextScroll";
import Title from "@/components/case-study/social-networking-app/Title";
import Layout from "@/components/layout/Layout";

const LinxCaseStudy = () => (
  <Layout
    description="NFC based Social Networking iOS and Android app developed by ultroNeous Technologies. Sharing social and personal information via mobile app is just a tap away."
    title="Social Networking App Through NFC | ultroNeous Technologies"
  >
    <div className="overflow-hidden">
      <Title />
      <TextScroll />
      <LinxVideo />
      <Card />
      <Scroll />
      <Requirements />
      <OurApproach />
      <AccordionScroll />
      <Accordion />
      <ResultScroll />
      <Result />
      <FeedbackScroll />
      <LinxFeedback />
      <NextLink
        nextImg={"/assets/case-study/next-case-study/cookie-cutter.webp"}
        nextLink={"/portfolio/cookie-cutter"}
        nextTitle={"Next <br/> case Study"}
      />
    </div>
  </Layout>
);

export default LinxCaseStudy;
